module.exports = __webpack_public_path__ + "img/dgitem12.6783fc62.png";